import { render, staticRenderFns } from "./NewProjectCard.vue?vue&type=template&id=678377c6&scoped=true&"
import script from "./NewProjectCard.vue?vue&type=script&lang=js&"
export * from "./NewProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectCard.vue?vue&type=style&index=0&id=678377c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678377c6",
  null
  
)

export default component.exports